import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { useMemo } from 'react'
import { useLocalStorage } from 'usehooks-ts'

export const IMPERSONATION_BANNER_CLOSED_KEY = 'marqii:global/impersonation-banner-closed'

export const useImpersonationBanner = () => {
  const { impersonation, accountId } = useCognitoAuth()
  const [isPrevClosed, saveIsPrevClosed] = useLocalStorage(IMPERSONATION_BANNER_CLOSED_KEY, false)

  const canBannerBeShown = useMemo(() => {
    return impersonation.isImpersonating && !isPrevClosed
  }, [impersonation, isPrevClosed])

  return {
    canBannerBeShown,
    saveIsPrevClosed,
    accountId,
  }
}
